import { BUMMER_TYPES } from "@/constants";
import { randomValues } from "@/lib/random";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_SPIN_COUNT, SET_BONUS_STATUS } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		title: "",
		activeBonus: false,
		active_insurance_types: [],
		base_spin_count: 2,
		bummers: {},
		spinsRemaining: 0,
	}),
	getters: {
		bummerCount: ({ bummers }) => Object.values(bummers).reduce((sum, type) => sum + type.count, 0),
		bummersByType: ({ bummers }) => (type) => randomValues(bummers[type].list, bummers[type].count),
	},
	actions: {
		activate({ dispatch, state, getters }) {
			const bummers = BUMMER_TYPES.reduce(
				(list, type) => {
					const obj = {};
					obj.list = getters.bummersByType(type);
					obj.frequency = getters.bummerCount / obj.list.length;
					obj.priority = obj.frequency / 2;

					return { ...list, [type]: obj };
				}, {}
			);

			dispatch("addSpins", { count: state.base_spin_count });
			dispatch("game/bummers/prepare", bummers, ROOT_FLAG);
		},
		addSpins({ commit, state }, spins) {
			const count = state.spinsRemaining + spins.count;
			commit(SET_SPIN_COUNT, { count });
		},
		removeSpins({ commit, state }, spins) {
			const count = state.spinsRemaining - spins.count;
			commit(SET_SPIN_COUNT, { count });
		},
		activateBonus({ commit }) {
			commit(SET_BONUS_STATUS, { activeBonus: true });
		},
		deactivateBonus({ commit }) {
			commit(SET_BONUS_STATUS, { activeBonus: false });
		},
		applyBonus({ dispatch, state }) {
			dispatch("game/balance/deposit", { amount: state.survival_bonus }, ROOT_FLAG);
		},
	},
	mutations: {
		[SET_SPIN_COUNT](state, spins) {
			state.spinsRemaining = spins.count;
		},
		[SET_BONUS_STATUS](state, bonus) {
			state.activeBonus = bonus.activeBonus;
		},
	},
};
